<app-modal [open]="active" [name]="'allbids-submitted'" (close)="closeDialog()">
  <div modal-header>Bids Submitted!</div>
  <div modal-body>
    All bids have been submitted and can be viewed from the
    <strong>Pending</strong> tab.
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    routerLink="/proposals"
    routerLinkActive="router-link-active"
    data-testid="allbids-submitted-view-pending"
    (click)="closeDialog()"
  >
    View Pending
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="allbids-submitted-close"
    (click)="closeDialog()"
  >
    Back
  </button>
</app-modal>
